import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FormVehicle from "./forms/FormVehicle";
import FormVehicleAndCustomer from "./forms/FormVehicleAndCustomer";

export const CadastrarClienteVeiculoModal = (props) => {
  const [onlyVehicle, setOnlyVehicle] = useState(false);

  const close = () => {
    props.setModalCadastroCliente(false);
  };

  return (
    <div>
      <Modal
        isOpen={props.open}
        toggle={close}
        backdrop="static"
        size="lg"
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
      >
        <ModalHeader className="no-select border-bottom-0 pb-0 pt-4 px-4" toggle={close}>
          <span className="fw-bold text-primary">Cadastro de Cliente e Veículo</span>
        </ModalHeader>

        <ModalBody className="p-4">
          {/* SEÇÃO DE SELEÇÃO: TIPO DE CADASTRO */}
          <div className="bg-light p-3 rounded-4 border mb-4">
            <div className="d-flex align-items-center mb-3">
              <i className="fas fa-layer-group me-2 text-primary"></i>
              <span className="fw-bold text-muted small text-uppercase">O que deseja cadastrar?</span>
            </div>

            <div className="d-flex flex-column flex-sm-row gap-4 ms-2">
              <div className="form-check custom-radio">
                <input
                  className="form-check-input cursor-pointer"
                  type="radio"
                  name="tipoCadastro"
                  id="radioClienteVeiculo"
                  style={{ width: '1.2em', height: '1.2em' }}
                  onChange={() => setOnlyVehicle(false)}
                  checked={!onlyVehicle}
                />
                <label className="form-check-label ps-2 cursor-pointer fw-bold text-dark" htmlFor="radioClienteVeiculo">
                  Veículo e Cliente
                </label>
                <div className="small text-muted ps-4">Cadastro completo para novos clientes.</div>
              </div>

              <div className="form-check custom-radio">
                <input
                  className="form-check-input cursor-pointer"
                  type="radio"
                  name="tipoCadastro"
                  id="radioSomenteVeiculo"
                  style={{ width: '1.2em', height: '1.2em' }}
                  onChange={() => setOnlyVehicle(true)}
                  checked={onlyVehicle}
                />
                <label className="form-check-label ps-2 cursor-pointer fw-bold text-dark" htmlFor="radioSomenteVeiculo">
                  Somente Veículo
                </label>
                <div className="small text-muted ps-4">Use para clientes com pressa ou que não querem se identificar.</div>
              </div>
            </div>
          </div>

          {/* RENDERIZAÇÃO DINÂMICA DO FORMULÁRIO */}
          <div className="mt-2">
            {onlyVehicle ? (
              <FormVehicle
                licensePlate={props.licensePlate}
                findVehicle={props.findVehicle}
                close={close}
              />
            ) : (
              <FormVehicleAndCustomer
                licensePlate={props.licensePlate}
                findVehicle={props.findVehicle}
                close={close}
              />
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default CadastrarClienteVeiculoModal;
